import Conversation from 'models/conversation';
import _ from 'lodash';

export function getActiveConversationId(conversationsStore) {
  const activeConversation = getActiveConversationAttributes(conversationsStore, ['id']);
  return activeConversation ? activeConversation.id : null;
}

export function getLatestConversationId(conversationsStore) {
  const latestConversation = getLatestConversationAttributes(conversationsStore, ['id']);
  return latestConversation ? latestConversation.id : null;
}

export function getActiveConversationAttributes(conversationsStore, selectAttributes) {
  const activeConversation = _.last(
    conversationsStore.findAll({ filter: c => c.status !== Conversation.Status.CLOSED, select: selectAttributes })
  );
  return activeConversation;
}

export function getLatestConversationAttributes(conversationsStore, selectAttributes) {
  const latestConversation = _.last(conversationsStore.findAll({ select: selectAttributes, sortBy: c => c.createdAt }));
  return getActiveConversationAttributes(conversationsStore, selectAttributes) || latestConversation || null;
}

export function getSortedConversationIds(conversationsStore) {
  let closedIds = conversationsStore
    .findAll({ filter: { status: Conversation.Status.CLOSED }, select: ['id'], sortBy: c => c.createdAt })
    .map(c => c.id);

  let active = _.last(
    conversationsStore.findAll({ filter: c => c.status !== Conversation.Status.CLOSED, select: ['id'] })
  );
  if (active) {
    return closedIds.concat(active.id);
  }

  return closedIds;
}

export function getSortedConversations(conversationsStore) {
  let closedConversations = conversationsStore.findAll({
    filter: { status: Conversation.Status.CLOSED },
    select: ['id', 'status', 'createdAt'],
    sortBy: c => c.createdAt,
  });

  let activeConversation = _.last(
    conversationsStore.findAll({
      filter: c => c.status !== Conversation.Status.CLOSED,
      select: ['id', 'status', 'createdAt'],
    })
  );
  if (activeConversation) {
    return closedConversations.concat(activeConversation);
  }

  return closedConversations;
}

export function getConversationAssignee(conversationStore) {
  let agentId = _.get(conversationStore, 'assignee.agentId');
  let groupId = _.get(conversationStore, 'assignee.routingGroupId');

  return { agentId, groupId };
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/lib/conversation_helpers.js